import { Spinner } from '@innovationdepartment/proxima-ui';
import React, { useCallback, useMemo, useState } from 'react';
import type { ISpinnerContext } from 'types/context/spinnerContext';

export const SpinnerWrapperContext = React.createContext<ISpinnerContext>({} as ISpinnerContext);

const SpinnerWrapperProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const showSpinner = useCallback((show: boolean = false) => setLoading(show), []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  const value = useMemo(() => ({ showSpinner }), []);

  return (
    <SpinnerWrapperContext.Provider value={value}>
      <Spinner loading={loading} />
      {children}
    </SpinnerWrapperContext.Provider>
  );
};

export default SpinnerWrapperProvider;
